module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/well/well-03_layoutphoto_01.png";